import { ACCESS_TOKEN_STORAGE_KEY } from "@frontend-shared/constants";
import type {
  IAnalyticsQueryParams,
  IRecentFlaggedMessagesParams,
} from "@frontend-shared/types";
import { useQuery } from "@tanstack/react-query";

import { analyticsApi } from "@/api/services";

export const ANALYTICS_QUERY_KEY = "analytics";

export const useGetUserAnalytics = (params: IAnalyticsQueryParams) => {
  const {
    dateFrom,
    dateTo,
    memberUuids,
    includeDeleted: shouldIncludeDeleted,
  } = params;
  return useQuery({
    queryKey: [
      ANALYTICS_QUERY_KEY,
      "user",
      dateFrom,
      dateTo,
      memberUuids,
      shouldIncludeDeleted,
    ],
    queryFn: () => analyticsApi.getUserAnalytics(params),
    enabled: !!localStorage.getItem(ACCESS_TOKEN_STORAGE_KEY),
  });
};

export const useGetMessagesSummary = (params: IAnalyticsQueryParams) => {
  const {
    dateFrom,
    dateTo,
    memberUuids,
    includeDeleted: shouldIncludeDeleted,
  } = params;
  return useQuery({
    queryKey: [
      ANALYTICS_QUERY_KEY,
      "summary",
      dateFrom,
      dateTo,
      memberUuids,
      shouldIncludeDeleted,
    ],
    queryFn: () => analyticsApi.getMessagesSummary(params),
    enabled: !!localStorage.getItem(ACCESS_TOKEN_STORAGE_KEY),
  });
};

export const useGetRecentFlaggedMessages = (
  params: IRecentFlaggedMessagesParams,
) => {
  const {
    limit,
    dateFrom,
    dateTo,
    memberUuids,
    includeDeleted: shouldIncludeDeleted,
  } = params;
  return useQuery({
    queryKey: [
      ANALYTICS_QUERY_KEY,
      "recent-flagged",
      limit,
      dateFrom,
      dateTo,
      memberUuids,
      shouldIncludeDeleted,
    ],
    queryFn: () => analyticsApi.getRecentFlaggedMessages(params),
    enabled: !!localStorage.getItem(ACCESS_TOKEN_STORAGE_KEY),
  });
};
